<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="form.deleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="form.createUser" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="form.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="form.updateUser" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="form.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="头像" prop="coverImage">
        <el-input v-model="form.coverImage" placeholder="请输入头像" v-trim/>
      </el-form-item>
      <el-form-item label="openid" prop="openid">
        <el-input v-model="form.openid" placeholder="请输入openid" v-trim/>
      </el-form-item>
      <el-form-item label="昵称" prop="nickName">
        <el-input v-model="form.nickName" placeholder="请输入昵称" v-trim/>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-input v-model="form.telephone" placeholder="请输入联系电话" v-trim/>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" v-trim/>
      </el-form-item>
      <el-form-item label="用工身份:0=未申请；1=申请中；2=已通过；3=未通过；" prop="workerIdentity">
        <el-input v-model="form.workerIdentity" placeholder="请输入用工身份:0=未申请；1=申请中；2=已通过；3=未通过；" v-trim/>
      </el-form-item>
      <el-form-item label="货运身份:0=未申请；1=申请中；2=已通过；3=未通过；" prop="driverIdentity">
        <el-input v-model="form.driverIdentity" placeholder="请输入货运身份:0=未申请；1=申请中；2=已通过；3=未通过；" v-trim/>
      </el-form-item>
      <el-form-item label="供餐很粉:0=未申请；1=申请中；2=已通过；3=未通过；" prop="chefIdentity">
        <el-input v-model="form.chefIdentity" placeholder="请输入供餐很粉:0=未申请；1=申请中；2=已通过；3=未通过；" v-trim/>
      </el-form-item>
      <el-form-item label="当前余额(单位:分)" prop="amount">
        <el-input v-model="form.amount" placeholder="请输入当前余额(单位:分)" v-trim/>
      </el-form-item>
      <el-form-item label="历史总金额(单位:分)" prop="totalAmount">
        <el-input v-model="form.totalAmount" placeholder="请输入历史总金额(单位:分)" v-trim/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态" v-trim/>
      </el-form-item>
      <el-form-item label="最后登录时间" prop="loginTime">
        <el-date-picker v-model="form.loginTime" value-format="yyyy-MM-dd" placeholder="请输入最后登录时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="总登录次数" prop="loginTimes">
        <el-input v-model="form.loginTimes" placeholder="请输入总登录次数" v-trim/>
      </el-form-item>
      <el-form-item label="总接单量" prop="reciveNum">
        <el-input v-model="form.reciveNum" placeholder="请输入总接单量" v-trim/>
      </el-form-item>
      <el-form-item label="总发单量" prop="publishNum">
        <el-input v-model="form.publishNum" placeholder="请输入总发单量" v-trim/>
      </el-form-item>
      <el-form-item label="评分" prop="score">
        <el-input v-model="form.score" placeholder="请输入评分" v-trim/>
      </el-form-item>
      <el-form-item label="定位地址" prop="localtion">
        <el-input v-model="form.localtion" placeholder="请输入定位地址" v-trim/>
      </el-form-item>
      <el-form-item label="纬度" prop="lat">
        <el-input v-model="form.lat" placeholder="请输入纬度" v-trim/>
      </el-form-item>
      <el-form-item label="经度" prop="lgt">
        <el-input v-model="form.lgt" placeholder="请输入经度" v-trim/>
      </el-form-item>
      <el-form-item label="省份" prop="province">
        <el-input v-model="form.province" placeholder="请输入省份" v-trim/>
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <el-input v-model="form.city" placeholder="请输入城市" v-trim/>
      </el-form-item>
      <el-form-item label="区县" prop="area">
        <el-input v-model="form.area" placeholder="请输入区县" v-trim/>
      </el-form-item>
      <el-form-item label="是否接受自动派单:0=否；1=是；" prop="autoReciveStatus">
        <el-input v-model="form.autoReciveStatus" placeholder="请输入是否接受自动派单:0=否；1=是；" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaMemberWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        coverImage: '',
        openid: '',
        nickName: '',
        telephone: '',
        name: '',
        workerIdentity: '',
        driverIdentity: '',
        chefIdentity: '',
        amount: '',
        totalAmount: '',
        status: '',
        loginTime: '',
        loginTimes: '',
        reciveNum: '',
        publishNum: '',
        score: '',
        localtion: '',
        lat: '',
        lgt: '',
        province: '',
        city: '',
        area: '',
        autoReciveStatus: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/member',
      'field.id': 'id'
    })
  }
}
</script>
